import { useState } from 'react';
import { Icon } from '@iconify/react';
import { Database } from 'lucide-react';

interface DBTypeIconProps {
    dbType?: string;
    className?: string;
    iconClassName?: string;
}

export default function DBTypeIcon({ dbType, className = "w-4 h-4", iconClassName }: DBTypeIconProps) {
    const [hasError, setHasError] = useState(false);

    if (!dbType || hasError) {
        return <Database className={className} />;
    }

    const formatIconName = (type: string) => {
        const lower = type.toLowerCase().trim();
        if (lower.includes('postgres')) return 'logos:postgresql';
        if (lower.includes('mysql')) return 'logos:mysql-icon';
        if (lower.includes('mongo')) return 'logos:mongodb-icon';
        if (lower.includes('redis')) return 'logos:redis';
        if (lower.includes('maria')) return 'logos:mariadb-icon';
        if (lower.includes('oracle')) return 'logos:oracle';
        if (lower.includes('sqlite')) return 'logos:sqlite';
        if (lower.includes('cockroach')) return 'logos:cockroachdb';
        if (lower.includes('clickhouse')) return 'thesvg-color:clickhouse';
        if (lower.includes('elastic')) return 'logos:elasticsearch';
        if (lower.includes('cassandra')) return 'logos:cassandra';
        if (lower.includes('opensearch')) return 'logos:opensearch-icon';
        if (lower.includes('mssql') || lower.includes('sqlserver') || lower.includes('sql server')) return 'thesvg-color:microsoft-sql-server';
        return `griddy-icons:sql`;
    };

    return (
        <Icon
            icon={formatIconName(dbType)}
            className={iconClassName || className}
            onError={() => setHasError(true)}
        />
    );
}
